"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.live = exports.TestContext = exports.LiveContext = void 0;
var _Function = require("./Function.js");
var defaultServices = _interopRequireWildcard(require("./internal/defaultServices.js"));
var layer = _interopRequireWildcard(require("./internal/layer.js"));
var TestClock = _interopRequireWildcard(require("./TestClock.js"));
var TestServices = _interopRequireWildcard(require("./TestServices.js"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/** @internal */
const live = exports.live = /*#__PURE__*/(0, _Function.pipe)( /*#__PURE__*/TestServices.annotationsLayer(), /*#__PURE__*/layer.merge( /*#__PURE__*/TestServices.liveLayer()), /*#__PURE__*/layer.merge( /*#__PURE__*/TestServices.sizedLayer(100)), /*#__PURE__*/layer.merge( /*#__PURE__*/(0, _Function.pipe)(TestClock.defaultTestClock, /*#__PURE__*/layer.provideMerge( /*#__PURE__*/layer.merge( /*#__PURE__*/TestServices.liveLayer(), /*#__PURE__*/TestServices.annotationsLayer())))), /*#__PURE__*/layer.merge( /*#__PURE__*/TestServices.testConfigLayer({
  repeats: 100,
  retries: 100,
  samples: 200,
  shrinks: 1000
})));
/**
 * @since 2.0.0
 */
const LiveContext = exports.LiveContext = /*#__PURE__*/layer.syncContext(() => defaultServices.liveServices);
/**
 * @since 2.0.0
 */
const TestContext = exports.TestContext = /*#__PURE__*/layer.provideMerge(live, LiveContext);
//# sourceMappingURL=TestContext.js.map